import {Component, OnInit, Input} from '@angular/core';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {Globals} from '@app/services/globals.service';
import {Router} from '@angular/router';
import {Task} from '@app/interfaces/task';

@Component({
    selector: 'app-task-minimized',
    templateUrl: './task-minimized.component.html',
    styleUrls: ['./task-minimized.component.css']
})
export class TaskMinimizedComponent implements OnInit {

    @Input() task: Task;
    @Input() emptyTask: boolean;

    assignedArray = [];
    previewAvatars = false;
    avatarWidth = 0;

    constructor(
                public proventumApiService: ProventumApiService,
                private globalsService: Globals,
                private router: Router) {
    }

    ngOnInit(): void {
        const users: any[] = this.globalsService.getAllUsers();

        if (this.emptyTask === false && this.task) {
            this.task.assigned.forEach(item => {
                const userData = users.find(x => x.id === item);
                this.assignedArray.push(userData);
                if (this.assignedArray !== []) {
                    this.previewAvatars = this.assignedArray.length > 0;
                }

            });
        }
    }

    async navigateTo(id) {
        await this.router.navigateByUrl('/view-task/' + id);
    }

}
